/* eslint-disable no-console */
import {
  addRequiredAttrs,
  clearInputValues,
  removeAllErrors,
  removeRequiredAttrs,
} from '../../utils/form-validation-utils';

// The change-password form is posted to ConsumerAccountPageController.ChangePassword by
// account-info-edit.js, so this module only manages the reveal/cancel state of the form
// (submission and validation happen on the server).

const showChangePasswordModule = () => {
  const form = document.querySelector('.acct-password-form');
  if (!form) {
    return;
  }
  addRequiredAttrs(form);
  const errorMsg = form.querySelector('.form-error-message');
  if (errorMsg) {
    errorMsg.classList.add('hide');
  }
};

const hideChangePasswordModule = () => {
  const form = document.querySelector('.acct-password-form');
  if (!form) {
    return;
  }
  clearInputValues(form);
  removeRequiredAttrs(form);
  removeAllErrors(form);
};

export {
  hideChangePasswordModule,
  showChangePasswordModule,
};
/* eslint-enable no-console */
